let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6JuSc")).then(() => parcelRequire('i7VyK'));